// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"qrCode-2w9vSezk","closeBtn":"closeBtn-3LuElqRy"};